/**
 * menu.i18n.js —— 顶部导航菜单 / 路由 meta.title 的中英文文案
 *
 * 命名规则：与 routerConfig.js 中 `meta.title` 与 navConfig.js 中 NAV_FALLBACK_* 一一对应。
 * 修改本文件即可同时影响：浏览器标题、顶部菜单、面包屑等消费 router meta.title 的地方。
 */

/**
 * 中文标题 → i18n key 映射。
 *
 * 用途：后端菜单节点若未配置 `meta.i18nKey`，用其中的中文 `meta.title` 反查本表，
 * 以保住英文界面的文案（见 utils/navConfig.js 的 resolveNavNodeLabel 回退链）。
 * 新增菜单时若后端不下发 i18nKey，需要在此补一行。
 */
export const TITLE_I18N_KEYS = {
  首页: 'home',
  探索: 'explore',
  总库检索: 'article',
  产品检索: 'subDb',
  报纸: 'newspaper',
  期刊: 'journal',
  视频: 'video',
  图书: 'book',
  图书集: 'bookCollection',
  专题: 'subject',
  跨库: 'crossDB'
}

export default {
  zh: {
    home: '首页',
    explore: '探索',
    article: '总库检索',
    subDb: '产品检索',
    newspaper: '报纸',
    journal: '期刊',
    video: '视频',
    book: '图书',
    bookCollection: '图书集',
    foreignMedia: '外媒',
    subject: '专题',
    login: '登录',
    logout: '退出登录',
    feature: '专题列表',
    detail: '细览页面',
    imageDetail: '图片细览页',
    imageProcess: '图片处理',
    source: '报史资料',
    newspaperDetail: '报纸详情',
    newspaperPageDetail: '版面细览',
    brandName: 'Green Apple',
    unavailable: '暂未开放，敬请期待',
    accountCenter: '个人中心',
    crossDB: '跨库'
  },
  en: {
    home: 'Home',
    explore: 'Explore',
    article: 'Full library',
    subDb: 'Product search',
    newspaper: 'Newspapers',
    journal: 'Journals',
    video: 'Videos',
    book: 'Books',
    bookCollection: 'Book Collections',
    foreignMedia: 'Foreign Media',
    subject: 'Topics',
    login: 'Log in',
    logout: 'Log out',
    feature: 'Topics',
    detail: 'Article',
    imageDetail: 'Image',
    imageProcess: 'Image processing',
    source: 'Historical sources',
    newspaperDetail: 'Newspaper details',
    newspaperPageDetail: 'Page details',
    brandName: 'Green Apple',
    unavailable: 'Coming soon',
    accountCenter: 'Account Center',
    crossDB: 'CrossDb'
  }
}
